import React, { useState } from "react";
import "../components/doctorListHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const DoctorListHeader = ({ onAddDoctorClicked, onSearchSpecialistEdited }) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault();
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      localStorage.setItem("searchValue", searchValue);
      e.preventDefault();
      if (searchValue.length > 2) {
        onSearchSpecialistEdited(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
        onSearchSpecialistEdited(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };
  return (
    <div className="doctor-header-container">
      <button className="add-doctor-button" onClick={onAddDoctorClicked}>
        <FaPlusCircle />
        Tambah Dokter Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Dokter"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default DoctorListHeader;
